import React, { useState, useEffect } from "react"
import { isFieldVisible, initFieldsConfig } from "./SignUpApplyFieldsConfigApi"

/**
 * A component that conditionally renders a field based on business type and category
 * @param {string} fieldName - The name of the field
 * @param {string} businessType - The business type (company_seeker, company_provider)
 * @param {string} category - The best describes category (corporation, financial, etc.)
 * @param {React.ReactNode} children - The field component to render
 * @returns {React.ReactNode} - The field component if it should be visible, null otherwise
 */
const ConditionalField = ({ fieldName, businessType, category, children }) => {
  const [visible, setVisible] = useState(false)

  // Initialize the configuration when the component mounts or when business type or category changes
  // The API will only make a network request if the config isn't already cached
  useEffect(() => {
    const fetchConfig = async () => {
      try {
        // initFieldsConfig will only fetch if not already cached
        await initFieldsConfig(businessType, category)

        // Check visibility after config is initialized or retrieved from cache
        const isVisible = isFieldVisible(fieldName, businessType, category)
        setVisible(isVisible)
      } catch (error) {
        console.error(
          `[DEBUG_LOG] Error initializing field config for ${fieldName}:`,
          error,
        )
      }
    }

    fetchConfig()
  }, [businessType, category, fieldName])

  // Render the field if it should be visible, otherwise render nothing
  return visible ? children : null
}

export default ConditionalField
